<template>
    <div>
        <client-only>
            <TransitionRoot as="template" :show="ModalShow">
              <Dialog as="div" class="relative z-10">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>
          
                <div class="fixed z-10 inset-0 overflow-y-auto">
                  <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                      <DialogPanel class="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                        
                        
                        <div v-show="ModalState == 'appt-submit-wait'"> 
                          <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100">
                              <svg class="animate-spin h-5 w-5 text-blue-600 h-6 w-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" >
                                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                              </svg>
                          </div>
          
                          <div class="mt-3 text-center sm:mt-5">
                            <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900"> 正在确认预约 </DialogTitle>
                            <div class="mt-2">
                              <p class="text-sm text-gray-500">正在确认您的预约，请勿关闭此页面</p>
                            </div>
                          </div>
                        </div>
    
                        <div v-if="ModalState == 'appt-submit-success'"> 
                          <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100">
                                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                                    <!-- <CheckIcon class="h-6 w-6 text-green-600" aria-hidden="true" /> -->
                                </div>
                          </div>
          
                          <div class="mt-3 text-center sm:mt-5">
                            <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900"> 预约请求提交成功 </DialogTitle>
                            <div class="mt-2">
                              <p class="text-sm text-gray-500">请等待诊所确认回复</p>
                              <p class="text-sm text-gray-500"> {{ doctorDetails.provider.cn_name }}医师 （{{ doctorDetails.provider.cn_specialty_1 }}）</p>
                              <p class="text-sm text-gray-500"> 诊所地址: {{ doctorDetails.facilities[0].en_full_address }}</p>
    
                              <p class="text-sm text-gray-500">就诊时间: {{ formatClinicDateTimeFromISO(selectedAppointmentSlot) }}（诊所当地时间）</p>
    
                              <p class="text-sm text-gray-500">确认代码: {{confirmationCode}}</p>
    
                              <!-- <p class="text-sm text-gray-500">{{lastNameEn}}, {{firstNameEn}} {{dobStr}}</p> -->
                              
                             
                            </div>
                            <div>
                             
                                <DoctorSchedulerQr url="`https://haodrs.com/qr/appt?id=${confirmationCode}&utm_src=conf_scan`"  ></DoctorSchedulerQr>
                               
                            </div>
                            <!-- <div class="mb-2">
                              <a class="underline text-blue-400" :href="`https://haodrs.com/qr/appt?id=${confirmationCode}`" target="_blank">{{`https://haodrs.com/qr/appt?id=${confirmationCode}`}}</a>
                            </div> -->
                            
                            <p class="text-sm text-gray-500">请拍照或截图保存此二维码，并妥善保管</p>
                            <p class="text-sm text-gray-500">您可通过扫描此二维码来管理您的预约和提取报告</p>
                          </div>
                          <!-- <button target="_blank" :href="`https://u.drwang.care/r?id=${confirmationCode}`" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 sm:col-start-1 sm:text-sm" >点击管理</button> -->
                        </div>
          
                        <div v-show="ModalState == 'slot-retrieve-wait'"> 
                          <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100">
                              <svg class="animate-spin h-5 w-5 text-blue-600 h-6 w-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" >
                                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                              </svg>
                          </div>
          
                          <div class="mt-3 text-center sm:mt-5">
                            <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900"> 正在获取可预约时段 </DialogTitle>
                            <div class="mt-2">
                              <p class="text-sm text-gray-500">正在获取最新数据，请稍后</p>
                            </div>
                          </div>
                        </div>
    
          
                        <div v-show="ModalState == 'default'"> 
                          <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100">
                              <svg class="animate-spin h-5 w-5 text-blue-600 h-6 w-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" >
                                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                              </svg>
                          </div>
          
                          <div class="mt-3 text-center sm:mt-5">
                            <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900"> 正在处理 </DialogTitle>
                            <div class="mt-2">
                              <p class="text-sm text-gray-500">请稍后</p>
                            </div>
                          </div>
                        </div>
          
                        <div v-show="ModalState == 'error'"> 
                          <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
                              <!-- <XCircleIcon class="h-6 w-6 text-red-600" aria-hidden="true" /> -->
                          </div>
          
                          <div class="mt-3 text-center sm:mt-5">
                            <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900"> 无法完成请求 </DialogTitle>
                            <div class="mt-2">
    
                              <p class="text-sm text-gray-500">{{ModalMessage}}</p>
                              
                              <p class="text-sm text-gray-500">如需帮助，您可拨平台24小时服务热线 +1(888)866-8656</p>
                            </div>
                          </div>
          
                          <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-1 sm:gap-3 sm:grid-flow-row-dense">
                          <button @click="setModalShow(false)" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-red-500 sm:col-start-1 sm:text-sm" >返回重试</button>
                          
                        </div>
                        </div>
    
                        <div v-show="ModalState == 'error-form-info'"> 
                          <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
                              <!-- <XCircleIcon class="h-6 w-6 text-red-600" aria-hidden="true" /> -->
                          </div>
          
                          <div class="mt-3 text-center sm:mt-5">
                            <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900"> 请检查填写信息 </DialogTitle>
                            <div class="mt-2">
                              <p class="text-sm text-gray-500">您填写的信息有误或不完整，请关闭此窗口后根据提示检查并重试</p>
                              <p class="text-sm text-gray-500">如需帮助，您可拨平台24小时服务热线 +1(888)866-8656</p>
                            </div>
                          </div>
          
                          <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-1 sm:gap-3 sm:grid-flow-row-dense">
                            <button @click="setModalShow(false)" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-red-500 sm:col-start-1 sm:text-sm" >返回重试</button>
                          
                          </div>
                        </div>
          
          
                         <!-- <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                            <CheckIcon class="h-6 w-6 text-green-600" aria-hidden="true" />
                          </div> -->
          
                        <!-- <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                          <button type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:col-start-2 sm:text-sm" @click="open = false">Deactivate</button>
                          <button type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:col-start-1 sm:text-sm" @click="open = false" ref="cancelButtonRef">Cancel</button>
                        </div> -->
                      </DialogPanel>
                    </TransitionChild>
                  </div>
                </div>
              </Dialog>
            </TransitionRoot>
        </client-only>
    </div>
    </template>
    
    <script setup>
    
    import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
    // import { CheckIcon, XCircleIcon } from '@heroicons/vue'
    
    
    const {
        targetDoctorId, targetFacilityId, targetDateTime, ptData, submitAppointmentRequest, selectedApptDate, SetselectedApptDate, getAppointmentSlots, AppointmentSlots, setAppointmentSlots, selectedAppointmentSlot, setSelectedAppointmentSlot, ModalShow,
        setModalShow,
        ModalState,
        setModalState,
        ModalMessage,
        setModalMessage,
        confirmationCode
     } = usePatientAppointmentRequest()
      const {
        doctorDetails
      } = useSearch()
      const { formatClinicDateTimeFromISO } = useClinicTimezone()
    
    </script>